import {Injectable, Signal, signal, WritableSignal} from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LoaderService {
  private readonly isLoading: WritableSignal<boolean> = signal<boolean>(false);
  isLoading$ = this.isLoading.asReadonly();

  setLoading(loading: boolean): void {
    this.isLoading.set(loading);
  }

  getLoading(): boolean {
    return this.isLoading();
  }
}
